export default __webpack_public_path__ + "static/media/file_icon.43065c4a.svg";